import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { CartItem } from '@dav-model/cart/cart-item.model';
import { ProductItem } from '@dav-model/response/getproducts.response';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class CartValidationService {
  constructor(private translateService: TranslateService) {}
  // calculate on cart component
  calculateCart(cartState: any, cartItem: CartItem, value: any) {
    this.validateCartCostByRetailType(value, cartState, cartItem);
  }

  // calculate on grid component
  static calculateGrid(productItem: ProductItem) {
    return this.calculateMarkup(productItem);
  }

  static calculateMarkup(product: ProductItem) {
    switch (product.retailRateType) {
      case 'NON-REG': {
        product = { ...product, customerCost: product.retailRate, costPlaceholder: product.retailRate };
        break;
      }
      default:
      case 'MAX':
      case 'FIXED': {
        product = { ...product, customerCost: +product.retailRate };
        break;
      }
    }

    return product;
  }

  validateCartCostByRetailType(value: any, cartState: any, cartItem: CartItem) {
    cartItem.product.errorFlag = false;
    cartItem.product.errorMessage = '';

    // Added reatil rate type check for other product types
    if (cartItem.product.retailRateType === 'MAX' || cartItem.product.retailRateType === 'FIXED') {
      if (value > +cartItem.product.retailRate) {
        cartItem.product.errorFlag = true;
        cartState.cartCostContainsError = true;
        // cartItem.product.errorMessage = `cost cannot exceed $${+cartItem.product.retailRate}`;
        cartItem.product.errorMessage = `${this.translateService.instant('errors.costExceed')} ${+cartItem.product
          .retailRate}`;
      }
    } else if (value === null || value === undefined) {
      cartItem.product.errorFlag = true;
      cartState.cartCostContainsError = true;
    }

    if (cartItem.product.errorFlag !== true) {
      this.recalculateTaxes(cartItem, value);
      cartItem.product.customerCost = value;
      const indx = cartState.validatedCart.findIndex((x) => x.key === cartItem.key);
      if (indx > -1) {
        cartState.validatedCart[indx].product.customerCost = value;
      }
      cartState.cartCostContainsError = false;
    }
    // Update modifed cart item in cart state
    cartState.validatedCart = cartState.validatedCart.map((cart) => {
      if (cart['key'] === cartItem['key']) {
        return cartItem;
      } else {
        return cart;
      }
    });
    // Validating error flag condition for updated cart items
    const isInvalid = cartState.validatedCart.some((cart) => cart['product']['errorFlag'] === true);
    cartState.cartCostContainsError = isInvalid || false;
  }

  validateGridCostByRetailType(value: any, product: ProductItem) {
    product.errorFlag = false;
    product.errorMessage = '';

    if (product.retailRateType === 'MAX') {
      if (value > +product.retailRate) {
        product.errorFlag = true;
        // product.errorMessage = `cost cannot exceed $${+product.retailRate}`;
        product.errorMessage = `${this.translateService.instant('errors.costExceed')} ${+product.retailRate}`;
      }
    } else if (value === null || value === undefined) {
      product.errorFlag = true;
    } else {
      product.errorFlag = false;
      product.errorMessage = '';
    }

    product.customerCost = value;
  }

  recalculateTaxes(cartItem: any, cost: number) {
    const customerTaxForm: UntypedFormGroup = cartItem.customerTaxFormGroup;
    if (customerTaxForm) {
      let total = 0;
      Object.keys(customerTaxForm.controls).forEach((key) => {
        if (key !== 'total') {
          const taxPercent = customerTaxForm.get(key)['taxPercentage'];
          let newTax = +(cost * taxPercent).toFixed(2);
          if (isNaN(newTax)) {
            newTax = 0;
          }
          // defer setting the value of tax fields so that their validators don't
          // run until the Cost field is updated.
          Promise.resolve().then(() => customerTaxForm.get(key).setValue(newTax));
          total += newTax;
        }
      });
      total += Number(cost);
      customerTaxForm.get('total').setValue(total.toFixed(2));
      customerTaxForm.updateValueAndValidity({ onlySelf: false, emitEvent: true });
    }
  }

  getTotal(cartItem: any): number {
    const customerTaxForm: UntypedFormGroup = cartItem.customerTaxFormGroup;
    let total = 0;
    if (customerTaxForm) {
      Object.keys(customerTaxForm.controls).forEach((key) => {
        if (key !== 'total') {
          if (customerTaxForm.get(key).value === null || isNaN(customerTaxForm.get(key).value)) {
            customerTaxForm.get(key).setValue(0);
          }
          const taxValue =
            Number(customerTaxForm.get(key).value) !== 0 ? +Number(customerTaxForm.get(key).value).toFixed(2) : 0;
          total += taxValue;
        }
      });
      total += Number(cartItem.product.customerCost);
    }

    return total;
  }
}
